// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PnMHomePageShimmerModuleScss from "../../styles/PnMHomePageShimmer.module.scss";

var styles = PnMHomePageShimmerModuleScss;

function PnmShiftItemFooterShimmerCmp(Props) {
  return React.createElement("div", {
              className: styles["items-container"]
            }, React.createElement("div", {
                  className: styles["items-container-header"]
                }, React.createElement("div", {
                      className: styles["item-header"]
                    })), React.createElement("div", {
                  className: styles["item-list"]
                }, React.createElement("div", {
                      className: styles["item-main"]
                    }, React.createElement("div", {
                          className: styles["item-icon"]
                        }), React.createElement("div", {
                          className: styles["item-name-container"]
                        }, React.createElement("div", {
                              className: styles["item-name-short"]
                            }), React.createElement("div", {
                              className: styles["item-name"]
                            })), React.createElement("div", {
                          className: styles["add-icon"]
                        }))), React.createElement("div", {
                  className: styles["item-list"]
                }, React.createElement("div", {
                      className: styles["item-main"]
                    }, React.createElement("div", {
                          className: styles["item-icon"]
                        }), React.createElement("div", {
                          className: styles["item-name-container"]
                        }, React.createElement("div", {
                              className: styles["item-name-short"]
                            }), React.createElement("div", {
                              className: styles["item-name"]
                            })), React.createElement("div", {
                          className: styles["add-icon"]
                        }))));
}

var make = PnmShiftItemFooterShimmerCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
